import { useState } from 'react';

import { ChevronDownIcon } from 'lucide-react';

import { cn } from '@nesso/ui/lib/utils';
import { Badge } from '@nesso/ui/primitives/badge';
import { Field } from '@nesso/ui/primitives/field';
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectLabel,
    SelectTrigger,
} from '@nesso/ui/primitives/select';

import { ACUITY_MENU_OPTIONS, ACUITY_TAG_OPTIONS } from '../config/acuity-options';
import type { Acuity } from '../model/acuity';

export function AssignAcuityTag() {
    const [acuity, setAcuity] = useState<Acuity>(null);
    const selectedValue = acuity ?? 'UNASSIGNED';
    const tag = ACUITY_TAG_OPTIONS[selectedValue];
    const TagIcon = tag.icon;

    return (
        <Field orientation="horizontal">
            <Select
                value={selectedValue}
                onValueChange={(value) =>
                    setAcuity(value === 'UNASSIGNED' ? null : (value as Acuity))
                }
            >
                <Badge asChild variant="outline">
                    <SelectTrigger asChild className="w-fit h-auto py-0.5">
                        <button type="button" tabIndex={0}>
                            <TagIcon className={cn('size-3', tag.iconClassName)} />
                            {tag.label}
                            <ChevronDownIcon className="size-3" />
                        </button>
                    </SelectTrigger>
                </Badge>
                <SelectContent align="start" className="min-w-48.25 p-1">
                    <SelectGroup>
                        <SelectLabel className="py-2.5">Acuity</SelectLabel>
                        {ACUITY_MENU_OPTIONS.map((option) => {
                            const OptionIcon = option.icon;
                            return (
                                <SelectItem key={option.value} value={option.value}>
                                    <span className="flex items-center gap-2">
                                        <OptionIcon
                                            className={cn('size-4', option.iconClassName)}
                                        />
                                        <span className="max-w-40 truncate" title={option.label}>
                                            {option.label}
                                        </span>
                                    </span>
                                </SelectItem>
                            );
                        })}
                    </SelectGroup>
                </SelectContent>
            </Select>
        </Field>
    );
}
